import React from 'react'
import { useNavigate } from 'react-router-dom'

const useRouteFunctions = () => {
    const Navigate = useNavigate();
    return {
        goToHomePage: () => Navigate('/'),
        goToDashboard: () => Navigate('/dashboard'),
        goToJobsPage: () => Navigate('/jobs'),
        goToDiscoverPage: () => Navigate('/discover'),
        goToLoginPage: () => Navigate('/auth/login'),
        goToForgotPasswordPage: () => Navigate('/auth/forgotpassword'),
    }
}

export default useRouteFunctions;